module.exports = __webpack_public_path__ + "img/jaizi.977c2001.png";